import { QrEntry } from './types'

type Props = {
  entries: QrEntry[]
  scannerElementId: string
  onPaste: (event: React.ClipboardEvent) => void
  onRemove: (containerId: string) => void
}

export const QrPasteZone = ({ entries, scannerElementId, onPaste, onRemove }: Props) => {
  const renderThumb = (entry: QrEntry) => (
    <div key={entry.previewUrl} className="qr-paste__thumb">
      <span
        className="qr-paste__thumb-remove"
        title="Удалить"
        onClick={() => onRemove(entry.containerId)}
      >
        ×
      </span>
      <img src={entry.previewUrl} alt="QR preview" />
    </div>
  )

  const renderThumbs = () => {
    if (entries.length === 0) return null

    return <div className="qr-paste__thumbs">{entries.map(renderThumb)}</div>
  }

  return (
    <>
      <div id={scannerElementId} className="qr-paste__scanner-host" />

      {/* tabIndex делает div фокусируемым по клику — иначе он не станет целью paste и onPaste не сработает. */}
      <div className="qr-paste__zone" tabIndex={0} onPaste={onPaste}>
        <span className="qr-paste__hint">Кликните сюда и вставьте скриншот (Ctrl+V)</span>
        {renderThumbs()}
      </div>
    </>
  )
}
